module.exports = __webpack_public_path__ + "img/ksa_flag.38167334.png";